var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapGridArea"},[_vm._m(0),_vm._m(1),_c('span',[_vm._v(" 개씩 보기")]),_c('SBGrid',{ref:"grid",staticStyle:{"width":"100%","height":"400px"},attrs:{"id":"grid","data":_vm.gridJson,"columns":_vm.grid1columns,"gridattr":{
			rowheader: 'seq',
			rowheadercaption : {seq: '순번'},
			rowheaderwidth: {seq: '80'},
			showtotalrows:true,
			paging: {
				'type' : 'all',
				'count' : 5,
				'size' : 5,
				'sorttype' : 'all',
				'showgoalpageui' : true
			},
		}}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_vm._v("Front Paging 처리 "),_c('span',{staticStyle:{"font-size":"12px","color":"#aaa","font-style":"italic"}},[_vm._v("DB로부터 데이터를 받아 Paging 기능을 사용할 수 있습니다.")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('select',{attrs:{"id":"","onChange":"pageSizeChanged(value)"}},[_c('option',{attrs:{"value":"5"}},[_vm._v("5")]),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"20"}},[_vm._v("20")])])
}]

export { render, staticRenderFns }